import type { JSX } from 'react';
import React from 'react';

import { Button } from '@feathr/components';

import type { ISampleReport } from '../sampleData';

interface IReportNameCellProps {
  onSelect: (report: ISampleReport) => void;
  report: ISampleReport;
}

/**
 * Table cell that renders a report name as a link button. Triggers the
 * provided `onSelect` callback when clicked so the host page can react
 * (e.g. open the prototype's Done modal).
 */
function ReportNameCell({ onSelect, report }: Readonly<IReportNameCellProps>): JSX.Element {
  function handleClick(): void {
    onSelect(report);
  }

  return (
    <Button onClick={handleClick} type={'link'}>
      {report.name}
    </Button>
  );
}

export default ReportNameCell;
